import { createContext } from 'react';
import type { SupportContextValue } from '../types/support.types';

/** One support session for all controls in the authenticated layout. */
export const SupportContext = createContext<SupportContextValue | null>(null);
